import type { LazyGoal } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/issue-goals/types';

export const createLazyGoals = (goalARIs: string[], isLoading = true): Record<string, LazyGoal> =>
	Object.fromEntries(goalARIs.map((goalARI) => [goalARI, { isLoading, goal: undefined }]));
